import React from "react";
import styles from "./CouncilActivityHeader.module.scss";

const CouncilActivityHeader = ({
  selectedActivity,
  setSelectedActivity,
  newsTitle,
}) => {
  return (
    <div className={styles["container"]}>
      <div>
        <span
          className={
            false === selectedActivity ? styles["active"] : styles["in-active"]
          }
          onClick={() => setSelectedActivity(false)}
        >
          Members
        </span>
      </div>
      <div>
        <span
          className={
            true === selectedActivity ? styles["active"] : styles["in-active"]
          }
          onClick={() => setSelectedActivity(true)}
        >
          {newsTitle}
        </span>
      </div>
    </div>
  );
};

export default CouncilActivityHeader;
